import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { styled } from "styled-components";
import { Menu, Moon, Sun, X } from "lucide-react";
import { Brand } from "./Brand";
import { Container } from "./UI";
import { useThemeMode } from "../AppProviders";

const Wrap = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.mode === "dark" ? "rgba(6,21,34,.88)" : "rgba(247,250,252,.9)"};
  backdrop-filter: blur(18px);
`;
const Bar = styled(Container)`
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;
const Nav = styled.nav<{ $open: boolean }>`
  display: flex;
  align-items: center;
  gap: .15rem;
  a {
    padding: .58rem .62rem;
    border-radius: 10px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.muted};
    font-weight: 740;
    font-size: .9rem;
    white-space: nowrap;
  }
  a:hover, a.active { color: ${({ theme }) => theme.colors.text}; background: ${({ theme }) => theme.colors.surface}; }
  @media (max-width: 1030px) {
    display: ${({ $open }) => $open ? "flex" : "none"};
    position: absolute;
    top: 82px;
    left: 1rem;
    right: 1rem;
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.surfaceElevated};
    border-radius: ${({ theme }) => theme.radii.md};
    box-shadow: 0 20px 50px ${({ theme }) => theme.colors.shadow};
  }
`;
const Actions = styled.div`display:flex;align-items:center;gap:.5rem;`;
const IconButton = styled.button`
  width: 42px; height: 42px; display: grid; place-items: center; border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.border}; color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surface}; cursor: pointer;
`;
const MenuButton = styled(IconButton)`display:none; @media(max-width:1030px){display:grid;}`;
const CTA = styled(Link)`
  padding: .65rem .9rem;
  border-radius: 999px;
  text-decoration: none;
  background: ${({ theme }) => theme.colors.accent};
  color: #04131e;
  font-weight: 850;
  font-size: .86rem;
  white-space: nowrap;
  @media(max-width:700px){display:none;}
`;

export function Header() {
  const [open, setOpen] = useState(false);
  const { mode, toggle: toggleTheme } = useThemeMode();
  const close = () => setOpen(false);
  return (
    <Wrap>
      <Bar>
        <Brand />
        <Nav $open={open} aria-label="Primary navigation">
          <NavLink to="/services" onClick={close}>Services</NavLink>
          <NavLink to="/website-solutions" onClick={close}>Website Solutions</NavLink>
          <NavLink to="/digital-marketing" onClick={close}>Digital Marketing</NavLink>
          <NavLink to="/ai-automation" onClick={close}>AI & Automation</NavLink>
          <NavLink to="/business-tools" onClick={close}>Business Tools</NavLink>
          <NavLink to="/pricing" onClick={close}>Pricing</NavLink>
          <NavLink to="/about" onClick={close}>About</NavLink>
        </Nav>
        <Actions>
          <IconButton onClick={toggleTheme} aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} theme`}>
            {mode === "dark" ? <Sun size={19}/> : <Moon size={19}/>} 
          </IconButton>
          <CTA to="/contact#schedule">Schedule a Consultation</CTA>
          <MenuButton onClick={() => setOpen(v => !v)} aria-label="Toggle navigation" aria-expanded={open}>
            {open ? <X size={21}/> : <Menu size={21}/>} 
          </MenuButton>
        </Actions>
      </Bar>
    </Wrap>
  );
}
